import { JSX, Show } from 'solid-js';

interface UserAvatarProps {
  picture?: string;
  name?: string;
  onClick?(): void;
  class?: string;
}

export const UserAvatar = (props: UserAvatarProps): JSX.Element => {
  const userInitials = (): string => {
    if (!props.name) return '-';
    return props.name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase();
  };

  return (
    <div
      class={`w-8 h-8 ${props.class || ''} ${
        props.onClick ? 'cursor-pointer' : ''
      }`}
      onClick={() => props.onClick?.()}
    >
      <Show
        when={props.picture}
        fallback={
          <div class="w-8 h-8 rounded-full bg-gray-3 flex items-center justify-center text-sm">
            {userInitials()}
          </div>
        }
      >
        <img
          src={props.picture}
          alt={props.name || 'User'}
          class="w-8 h-8 rounded-full object-cover"
        />
      </Show>
    </div>
  );
};
